module.exports = __webpack_public_path__ + "img/option-6.a8f123e3.png";